import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/auth";
import type { Module } from "@/interfaces";
import api from "@/lib/axios";

interface PlatformResponse {
  data: {
    id: number;
    have_access: boolean;
    default: boolean;
    menus: Module[];
  }[];
}

async function fetchClientModules(userId: number): Promise<Module[]> {
  const { data } = await api.get<PlatformResponse>(`user/${userId}/platform`);
  const platformData = data.data?.[0];
  return platformData?.have_access ? (platformData?.menus ?? []) : [];
}

export function useClientModules() {
  const { userId } = useAuth();

  return useQuery({
    queryKey: ["client-modules", userId],
    queryFn: () => fetchClientModules(userId as number),
    enabled: userId !== null,
  });
}
